<template>
    <!--
        Money — tabular-number cell. Renders an em-dash for null/zero
        (de-emphasised). Uses the design's tag-mono + tag-tnum utilities
        from tokens.css.
    -->
    <span class="tag-mono tag-tnum" :style="rootStyle">{{ display }}</span>
</template>

<script>
export default {
    name: "Money",
    props: {
        value: { default: null },
        muted: { type: Boolean, default: false },
    },
    computed: {
        numeric() {
            if (this.value === null || this.value === undefined || this.value === "") return null;
            const n = Number(String(this.value).replace(/[,$\s]/g, ""));
            return Number.isFinite(n) ? n : null;
        },
        isEmpty() {
            return this.numeric === null || this.numeric === 0;
        },
        display() {
            if (this.isEmpty) return "—";
            return this.numeric.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        rootStyle() {
            if (this.isEmpty) return { color: "var(--text-faint)" };
            return { color: this.muted ? "var(--text-muted)" : "var(--text)" };
        },
    },
};
</script>
